import React from 'react';
import { Form } from 'formik-antd';
import styled from 'styled-components';

export const Input = styled(Form.Item)`
	.ant-form-item-label {
		margin: 0;
		line-height: 0;
		padding: 0;
		label {
			font-size: 16px;
			line-height: 24px;
		}
	}
`;

export default function FormInput(props) {
	return (
		<Input
			hasFeedback={false}
			showValidateSuccess={false}
			labelCol={{ span: 24 }}
			wrapperCol={{ span: 24 }}
			{...props}
		/>
	);
}
